/**
 * TicketPreviewWebFrame.tsx — Marco web reutilizable del ticket (papel rasgado + padding).
 *
 * QUÉ EXPORTA: TicketPreviewWebFrame
 * QUÉ NO DEBE HACER: Lógica de negocio, datos de venta/cierre/movimiento ni impresión.
 */

import type { ReactNode } from "react";
import { TicketTornPaperShell } from "@/features/caja/components/TicketTornPaperShell";
import { TICKET_PREVIEW_MODAL_FRAME_CLASS } from "@/features/caja/constants/ticketTornPaper";

interface TicketPreviewWebFrameProps {
  children: ReactNode;
  className?: string;
  shellClassName?: string;
  /** Borde rojo sutil (venta anulada, devolución, etc.). */
  anulada?: boolean;
  withWatermark?: boolean;
}

/**
 * Centra el ticket blanco con bordes rasgados sobre el lienzo claro del modal.
 */
export function TicketPreviewWebFrame({
  children,
  className = "",
  shellClassName = "",
  anulada = false,
  withWatermark = false,
}: TicketPreviewWebFrameProps) {
  return (
    <div className={`${TICKET_PREVIEW_MODAL_FRAME_CLASS} ${className}`}>
      <TicketTornPaperShell
        anulada={anulada}
        className={[
          "ticket-print-area font-mono text-[11px] leading-snug overflow-visible w-full",
          shellClassName,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="relative p-3 sm:p-6">
          {withWatermark ? (
            <div
              className="ticket-watermark pointer-events-none absolute inset-0 z-0"
              aria-hidden
            />
          ) : null}
          <div className="relative z-[1]">{children}</div>
        </div>
      </TicketTornPaperShell>
    </div>
  );
}
